var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "インポート",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            "modal-class": "custom-modal",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c("div", [
            _c("div", { staticStyle: { width: "1200px" } }, [
              _vm.master_name == "mitumori"
                ? _c("span", [
                    _c("div", { staticClass: "form-inline" }, [
                      _vm._v("\n            1.発注先を選択\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-inline" },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticStyle: {
                              width: "200px",
                              "margin-left": "10px",
                            },
                            on: { change: _vm.SelHattyuCompany },
                            model: {
                              value: _vm.hattyu_company_sel,
                              callback: function ($$v) {
                                _vm.hattyu_company_sel = $$v
                              },
                              expression: "hattyu_company_sel",
                            },
                          },
                          _vm._l(_vm.hattyu_company_list, function (option) {
                            return _c(
                              "option",
                              {
                                key: option.id,
                                domProps: { value: option.value },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.text) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("span", [
                    _c("div", { staticClass: "form-inline" }, [
                      _vm._v(
                        "\n            2.品題、品類、品目を設定\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-inline" }, [
                      _c(
                        "table",
                        {
                          staticClass: "header_tbl",
                          staticStyle: {
                            "margin-left": "10px",
                            "margin-top": "-10px",
                          },
                        },
                        [
                          _c("tr", [
                            _c("th", { staticStyle: { width: "200px" } }, [
                              _vm._v("品題"),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticStyle: { width: "200px" } }, [
                              _vm._v("品類"),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticStyle: { width: "200px" } }, [
                              _vm._v("品目"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              [
                                _c("b-input", {
                                  staticStyle: {
                                    width: "180px",
                                    "background-color": "white",
                                  },
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.title,
                                    callback: function ($$v) {
                                      _vm.title = $$v
                                    },
                                    expression: "title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("b-input", {
                                  staticStyle: {
                                    width: "180px",
                                    "background-color": "white",
                                  },
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.teiki_type1,
                                    callback: function ($$v) {
                                      _vm.teiki_type1 = $$v
                                    },
                                    expression: "teiki_type1",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("b-input", {
                                  staticStyle: {
                                    width: "180px",
                                    "background-color": "white",
                                  },
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.teiki_type2,
                                    callback: function ($$v) {
                                      _vm.teiki_type2 = $$v
                                    },
                                    expression: "teiki_type2",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("div", { staticClass: "form-inline" }, [
                    _vm._v(
                      "\n          3.CSVファイルを選択\n             ※ファイルの種類(エンコード)は「UTF-8」にして下さい\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-left": "20px" } },
                [
                  _c("b-form-file", {
                    staticStyle: {
                      width: "500px",
                      "text-align": "left !important",
                      float: "left !important",
                    },
                    attrs: {
                      state: Boolean(_vm.csv_file),
                      accept: "text/csv",
                      placeholder: "Choose a file or drop it here...",
                    },
                    on: { change: _vm.upload_csv_file },
                    model: {
                      value: _vm.csv_file,
                      callback: function ($$v) {
                        _vm.csv_file = $$v
                      },
                      expression: "csv_file",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("div", { staticClass: "form-inline" }, [
                    _vm._v("\n          4.ヘッダーを設定\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("div", { staticClass: "form-inline" }, [
                    _c(
                      "table",
                      {
                        staticClass: "header_tbl",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [
                        _c("tr", [
                          _c("th", [_vm._v("納品書番号")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("受注日")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("顧客名")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("商品コード")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("数量")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("単価(税抜)")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("単価(税込)")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("税率")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tr",
                          _vm._l(8, function (n) {
                            return _c(
                              "td",
                              { key: n },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    staticStyle: { width: "130px" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onHeaderChanged(n - 1)
                                      },
                                    },
                                    model: {
                                      value: _vm.header_sel[n - 1],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.header_sel, n - 1, $$v)
                                      },
                                      expression: "header_sel[n - 1]",
                                    },
                                  },
                                  [
                                    _c("option"),
                                    _vm._v(" "),
                                    _vm._l(_vm.header_list, function (option) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.id,
                                          domProps: { value: option.value },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(option.text) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("div", { staticClass: "form-inline" }, [
                    _vm._v("\n          5.顧客、担当者を設定\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c(
                    "div",
                    {
                      staticClass: "form-inline",
                      staticStyle: { "margin-left": "10px" },
                    },
                    [
                      _c("SelectClientCompany", {
                        ref: "select_client_company_ref",
                        on: { on_select: _vm.onClientCompanySelect },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c("div", { staticClass: "form-inline" }, [
                    _c(
                      "table",
                      {
                        staticClass: "header_tbl",
                        staticStyle: {
                          "margin-left": "10px",
                          "margin-top": "-10px",
                        },
                      },
                      [
                        _c("tr", [
                          _c("th", { staticStyle: { width: "280px" } }, [
                            _vm._v("import元"),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { width: "280px" } }, [
                            _vm._v("import先"),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { width: "150px" } }, [
                            _vm._v("担当者"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.bef_client_company_list, function (list, i) {
                          return _c("tr", { key: i }, [
                            _c(
                              "td",
                              { staticStyle: { "max-width": "280px" } },
                              [_vm._v(_vm._s(list))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "max-width": "280px" } },
                              [
                                _c("b-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "background-color": "white",
                                  },
                                  attrs: { type: "text", readonly: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectClientCompanyModalShow(i)
                                    },
                                  },
                                  model: {
                                    value: _vm.aft_client_company_list[i][1],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.aft_client_company_list[i],
                                        1,
                                        $$v
                                      )
                                    },
                                    expression: "aft_client_company_list[i][1]",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.loading[i]
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "icon_btn",
                                        attrs: { variant: "info" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectClientCompanyModalShow(
                                              i
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "search",
                                            "aria-hidden": "true",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loading[i]
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "icon_btn",
                                        attrs: {
                                          variant: "info",
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "spinner-border spinner-border-sm",
                                          attrs: {
                                            role: "status",
                                            "aria-hidden": "true",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { width: "150px" } },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    staticStyle: {
                                      width: "200px",
                                      "margin-left": "10px",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onUserChange(i)
                                      },
                                    },
                                    model: {
                                      value: _vm.aft_user_list[i],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.aft_user_list, i, $$v)
                                      },
                                      expression: "aft_user_list[i]",
                                    },
                                  },
                                  _vm._l(_vm.sel_person, function (option) {
                                    return _c(
                                      "option",
                                      {
                                        key: option.id,
                                        domProps: { value: option.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(option.text) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                          ])
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name == "mitumori"
                ? _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("div", { staticStyle: { "margin-left": "800px" } }, [
                        _vm._v(
                          "\n            インポート済みの納品書番号は保存されません\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "985px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary" },
                              on: { click: _vm.csvImport },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" インポート\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "985px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary", disabled: "" },
                            },
                            [
                              _c("b-spinner", { attrs: { small: "" } }),
                              _vm._v("\n            Loading...\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }